import React, { useState } from "react";

// import JS files
import Navbar from "../shares/others/Navbar";
import Footer from "../shares/others/Footer";
import Breadcrumb from "../shares/others/Breadcrumb";
import Filter from "./Filter";
import MuiPagination from "../shares/mui/MuiPagination";
import moment from "jalali-moment";

// import others files
import samplePic from "../../assets/imgs/person-sample.png";
import NewsCard from "./NewsCard";
import MobileFilter from "./MobileFilter";
import useFetch from "../../context/useFetch";
import { useParams } from "react-router-dom";

const breadcrumbList = ["صفحه اصلی", "اخبار"];

const NewsList = (props) => {
  const { search ,tag } = useParams();
  const [newsType, setNewsType] = useState(
    search !== undefined ? search : "all"
  );
  const [tagType, setTagType] = useState(
    tag !== undefined ? tag : undefined
  );
  const [newsDate, setNewsDate] = useState(null);

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 10,
    count: 0,
  });

  const [newsList, setNewsList] = useState({ results: [] });
  const getNewsListApi = useFetch({
    method: "get",
    pagination: paginationPageInfo,
    params: {
      type: newsType,
      tag_name:tagType,
      date: newsDate !== null ? moment(newsDate).format("YYYY-MM-DD") : null,
    },
    url: "News_Service",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setNewsList(res);
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
  });

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    // setNewsList({ results: [] });
    getNewsListApi.reFetch();
  };

  const filter_api = () => {
    getNewsListApi.reFetch();
  };
  return (
    <>
      <Navbar active_item="news" />
      <div className="mx-8 mt-8 mb-16" style={{ fontFamily: "yekan" }}>
        <Breadcrumb list={breadcrumbList} />
        <div className="my-4 md:hidden">
          <MobileFilter
            header="اخبار"
            newsType={newsType}
            setNewsType={setNewsType}
            newsDate={newsDate}
            setNewsDate={setNewsDate}
            filter_api={filter_api}
          />
        </div>
        <Filter
          newsType={newsType}
          setNewsType={setNewsType}
          newsDate={newsDate}
          setNewsDate={setNewsDate}
          filter_api={filter_api}
        />
        {newsList.results.map((item, index) => {
          return (
            <NewsCard
              id={item.id}
              img={item.news_detail[0].cover}
              header={item.news_detail[0].header}
              sub_header={item.news_detail[0].sub_header}
              comment={item.ticket_num}
              date={item.news_detail[0].publish_at}
              brief_description={item.news_detail[0].brief_description}
            />
          );
        })}
        <div className="flex justify-center">
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NewsList;
